import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'inputWithCopy',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      lang: 'en',
    }
  },
  created() {
    this.lang = this.$localStorage.get('_lang');
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.value);

      //this.$refs.clone.focus();
      //document.execCommand('copy');
    },
    getButtonStyle() {
      if (this.lang == 'ar') {
        return 'margin-right: -40px';
      } else {
        return 'margin-left: -40px';
      }
    }
  },
}

